export interface SubmitJobWizardState {
  workspaceId: string;
  workspaceCloud: string;
  sparkEngineId: string;
  sparkEngineName: string;
  name: string;
  entryPoint: string;
  entryPointArguments: string;
  sparkConfig: { key: string; value: string }[];
  environmentVariables: { key: string; value: string }[];
  retryEnabled: boolean;
  maxRetries: number;
  cooldownInterval: number;
  jobTimeout: string;
}

export const defaultSubmitJobWizardState: SubmitJobWizardState = {
  workspaceId: '',
  workspaceCloud: '',
  sparkEngineId: '',
  sparkEngineName: '',
  name: '',
  entryPoint: '',
  entryPointArguments: '',
  sparkConfig: [{ key: '', value: '' }],
  environmentVariables: [{ key: '', value: '' }],
  retryEnabled: false,
  maxRetries: 3,
  cooldownInterval: 60,
  jobTimeout: '',
};
